import { defineNuxtPlugin } from '#app'
import {
  GeneralAutomationSettingsType,
  IntegrationsAutomationSettingsType,
} from '@grouper/modules/automation/automationSettingTypes'

import { AutomationApplicationType } from '@grouper/modules/automation/applicationTypes'
import automationApplicationStore from '@grouper/modules/automation/store/automationApplication'
import automationWorkflowStore from '@grouper/modules/automation/store/automationWorkflow'
import automationWorkflowNodeStore from '@grouper/modules/automation/store/automationWorkflowNode'
import automationHistoryStore from '@grouper/modules/automation/store/automationHistory'
import {
  LocalGrouperCreateRowActionNodeType,
  LocalGrouperCreateRowsActionNodeType,
  LocalGrouperUpdateRowActionNodeType,
  LocalGrouperUpdateRowsActionNodeType,
  LocalGrouperDeleteRowActionNodeType,
  LocalGrouperGetRowActionNodeType,
  LocalGrouperListRowsActionNodeType,
  LocalGrouperRowsCreatedTriggerNodeType,
  LocalGrouperRowsUpdatedTriggerNodeType,
  LocalGrouperRowsDeletedTriggerNodeType,
  LocalGrouperFieldsUpdatedTriggerNodeType,
  CoreHTTPTriggerNodeType,
  LocalGrouperAggregateRowsActionNodeType,
  CoreCSVFileReaderNodeType,
  CoreHttpRequestNodeType,
  CoreIteratorNodeType,
  CoreSMTPEmailNodeType,
  CoreRouterNodeType,
  CoreGotoNodeType,
  CorePeriodicTriggerNodeType,
  CoreStartWorkflowNodeType,
  CoreManualTriggerNodeType,
  AIAgentActionNodeType,
  SlackWriteMessageNodeType,
} from '@grouper/modules/automation/nodeTypes'
import {
  DuplicateAutomationWorkflowJobType,
  PublishAutomationWorkflowJobType,
} from '@grouper/modules/automation/jobTypes'
import { WorkflowDisabledNotificationType } from '@grouper/modules/automation/notificationTypes.jsx'
import {
  HistoryEditorSidePanelType,
  NodeEditorSidePanelType,
} from '@grouper/modules/automation/editorSidePanelTypes'
import { AutomationSearchType } from '@grouper/modules/automation/searchTypes'
import { searchTypeRegistry } from '@grouper/modules/core/search/types/registry'
import { AutomationGuidedTourType } from '@grouper/modules/automation/guidedTourTypes'
import {
  PreviousNodeDataProviderType,
  CurrentIterationDataProviderType,
} from '@grouper/modules/automation/dataProviderTypes'

export default defineNuxtPlugin({
  name: 'automation',
  dependsOn: ['core', 'store'],
  setup(nuxtApp) {
    const { $registry, $store } = nuxtApp

    const context = { app: nuxtApp }

    // Register stores
    $store.registerModuleNuxtSafe(
      'automationApplication',
      automationApplicationStore
    )
    $store.registerModuleNuxtSafe('automationWorkflow', automationWorkflowStore)
    $store.registerModuleNuxtSafe(
      'automationWorkflowNode',
      automationWorkflowNodeStore
    )
    $store.registerModuleNuxtSafe('automationHistory', automationHistoryStore)
    $store.registerModuleNuxtSafe(
      'template/automationApplication',
      automationApplicationStore
    )

    $registry.registerNamespace('automationDataProvider')
    $registry.registerNamespace('node')
    $registry.registerNamespace('editorSidePanel')

    // Automation data providers
    $registry.register('application', new AutomationApplicationType(context))
    $registry.register(
      'automationDataProvider',
      new PreviousNodeDataProviderType(context)
    )
    $registry.register(
      'automationDataProvider',
      new CurrentIterationDataProviderType(context)
    )

    // Automation node types
    $registry.register(
      'node',
      new LocalGrouperRowsCreatedTriggerNodeType(context)
    )
    $registry.register(
      'node',
      new LocalGrouperRowsUpdatedTriggerNodeType(context)
    )
    $registry.register(
      'node',
      new LocalGrouperRowsDeletedTriggerNodeType(context)
    )
    $registry.register(
      'node',
      new LocalGrouperFieldsUpdatedTriggerNodeType(context)
    )
    $registry.register('node', new CoreHTTPTriggerNodeType(context))
    $registry.register('node', new LocalGrouperCreateRowActionNodeType(context))
    $registry.register(
      'node',
      new LocalGrouperCreateRowsActionNodeType(context)
    )
    $registry.register('node', new LocalGrouperUpdateRowActionNodeType(context))
    $registry.register(
      'node',
      new LocalGrouperUpdateRowsActionNodeType(context)
    )
    $registry.register('node', new CoreHttpRequestNodeType(context))
    $registry.register('node', new CoreSMTPEmailNodeType(context))
    $registry.register('node', new CoreRouterNodeType(context))
    $registry.register('node', new CoreGotoNodeType(context))
    $registry.register('node', new CoreIteratorNodeType(context))
    $registry.register('node', new CoreCSVFileReaderNodeType(context))
    $registry.register('node', new CoreStartWorkflowNodeType(context))
    $registry.register('node', new SlackWriteMessageNodeType(context))
    $registry.register('node', new LocalGrouperDeleteRowActionNodeType(context))
    $registry.register('node', new LocalGrouperGetRowActionNodeType(context))
    $registry.register('node', new LocalGrouperListRowsActionNodeType(context))
    $registry.register(
      'node',
      new LocalGrouperAggregateRowsActionNodeType(context)
    )
    $registry.register('node', new CorePeriodicTriggerNodeType(context))
    $registry.register('node', new CoreManualTriggerNodeType(context))
    $registry.register('node', new AIAgentActionNodeType(context))

    // Automation job types
    $registry.register('job', new DuplicateAutomationWorkflowJobType(context))
    $registry.register('job', new PublishAutomationWorkflowJobType(context))
    $registry.register(
      'notification',
      new WorkflowDisabledNotificationType(context)
    )

    // Automation settings
    $registry.registerNamespace('automationSettings')
    $registry.register(
      'automationSettings',
      new GeneralAutomationSettingsType(context)
    )
    $registry.register(
      'automationSettings',
      new IntegrationsAutomationSettingsType(context)
    )

    // Automation editor side panels
    $registry.register('editorSidePanel', new NodeEditorSidePanelType(context))
    $registry.register(
      'editorSidePanel',
      new HistoryEditorSidePanelType(context)
    )

    // Automation search type
    searchTypeRegistry.register(new AutomationSearchType(context))

    // Automation guided tour
    $registry.register('guidedTour', new AutomationGuidedTourType(context))
  },
})
